import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';


const PrivateRoute = ({ component: Component, ...rest }) => {
  const checkAuth = rest.isLoggedIn;
  return (
    <Route
      {...rest}
      render={props =>
        checkAuth === true ? (
          <Component {...props} {...rest} />
        ) : (
          <Redirect
            to={{
              pathname: '/',
            }}
          />
        )
      }
    />
  );
};

export default PrivateRoute;

PrivateRoute.propTypes = {
  location: ReactRouterPropTypes.location,
  history: ReactRouterPropTypes.history,
  component: PropTypes.any,
};